/** Focuses the sticky header search from the mobile tab without changing the page position. */
class SMobileSearchTab extends HTMLElement {
  #abort;

  connectedCallback() {
    this.#abort = new AbortController();
    this.addEventListener('click', (event) => {
      const input = document.getElementById('sahla-header-search');
      if (!input || input.getClientRects().length === 0) return;

      event.preventDefault();
      input.focus({ preventScroll: true });
    }, { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }
}

customElements.define('s-mobile-search-tab', SMobileSearchTab);
